import { LockOutlined, SafetyOutlined } from '@ant-design/icons';
import { Alert, Card, Space, Typography } from 'antd';
import React from 'react';
import { useMedia } from 'react-use';
import { BREAKPOINTS } from '../common/constants';

const { Text, Title } = Typography;

const RestrictedAccess = ({
  message = 'You do not have the necessary permissions to access this content.',
  title = 'Access Restricted',
  className = '',
  type = 'card',
}) => {
  const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS?.desktop}px)`);

  if (type === 'alert') {
    return (
      <div className={`restricted-access-wrapper ${className}`}>
        <Alert
          className={`restricted-access-alert ${!isDesktopViewport ? 'mobile-restricted-access' : ''}`}
          title={title}
          description={
            <Space orientation="vertical" size={4}>
              <Text>{message}</Text>
              <Text type="secondary" className="restricted-access-contact-hint">
                Contact your project administrator for access.
              </Text>
            </Space>
          }
          type="warning"
          icon={<SafetyOutlined />}
          showIcon
        />
      </div>
    );
  }

  return (
    <div className={`restricted-access-wrapper ${className}`}>
      <Card
        className={`restricted-access-card ${!isDesktopViewport ? 'mobile-card' : ''}`}
        variant="borderless"
      >
        <Space
          orientation="vertical"
          className={`restricted-access-content ${!isDesktopViewport ? 'mobile-content' : ''}`}
        >
          <div className="restricted-access-icon-container">
            <div className="restricted-access-icon-wrapper">
              <div className="restricted-access-main-icon">
                <SafetyOutlined />
              </div>
              <div className="restricted-access-lock-badge">
                <LockOutlined />
              </div>
            </div>
          </div>
          <div className="restricted-access-text-content">
            <Title
              level={isDesktopViewport ? 3 : 4}
              className="restricted-access-title"
            >
              {title}
            </Title>
            <Text className="restricted-access-message">{message}</Text>
          </div>
        </Space>
      </Card>
    </div>
  );
};

export default RestrictedAccess;
